import { all, call, put, select, takeLatest } from "redux-saga/effects";

import {
  checkInOnlineStart,
  checkInOnlineSuccess,
  checkInOnlineFailed,
} from "../redux/checkInOnline";
import { toast } from "react-toastify";

import { ErrorMessage } from "core/http/service/decleareLeave/const";
import { checkInOnlineApi } from "core/http/service/timeKeeping";
import { SCREEN } from "helper/roleChecker/Screens";
import { selectMonthYearTimeCheckingData } from "../redux/selector";
import { getTimeCheckingStart } from "../redux/getTimeKeeping";

function* checkInOnlineWork(action) {
  const screenCode = action.payload;

  try {
    yield call(checkInOnlineApi, screenCode);

    yield put({
      type: checkInOnlineSuccess.type,
    });
    const { year, month } = yield select(selectMonthYearTimeCheckingData);
    yield put({
      type: getTimeCheckingStart.type,
      payload: {
        id: `${year}-${month}`,
        month,
        year,
        screenCode: SCREEN.IP_016,
      },
    });
  } catch (error: any) {
    toast.error(
      Object.keys(ErrorMessage).includes(error?.response?.data?.code)
        ? ErrorMessage[error?.response?.data?.code]
        : (error?.response?.data?.message ?? "Có lỗi xảy ra")
    );
    yield put({
      type: checkInOnlineFailed.type,
    });
  }
}

function* watchCheckInOnline() {
  yield takeLatest(checkInOnlineStart.type, checkInOnlineWork);
}

export default function* checkInOnlineSaga() {
  yield all([watchCheckInOnline()]);
}
